module.exports = __webpack_public_path__ + "static/jetcraft-2986fb58245f80b670aef16a39505d9d.png";